<ngx-loading-bar [color]="'#42a5f5'" [includeSpinner]="false" ></ngx-loading-bar>
<router-outlet></router-outlet> <!-- actual layout presentation is in core/layout -->


// WEBPACK FOOTER //
// ./client/app/app.component.html